import { useEffect, useState } from 'react'
import { useGetIdCheckUrl } from './useApi'
import { useGetNotificationStatusesV2 } from './useApiQuery'
import { usePrevious } from '../components/shared/usePrevious'
import { usePageVisibility } from '../components/shared/usePageVisibility'

export function useIdCheckFlow(orderKey: string, notificationId: string, search: string) {
  const [openedIdCheckUrl, setOpenedIdCheckUrl] = useState(false)
  const [idCheckUrl, setIdCheckUrl] = useState('')
  const [isPolling, setIsPolling] = useState(false)

  const {
    refresh: refreshGetIdCheckUrl,
    loading: getIdCheckUrlLoading,
    error: getIdCheckUrlError,
    data: getIdCheckUrlSuccess,
    resetState: resetGetIdCheckUrl,
  } = useGetIdCheckUrl(orderKey, notificationId, search)

  const isVisible = usePageVisibility()
  const prevIsVisible = usePrevious(isVisible)

  const notificationStatusesQuery = useGetNotificationStatusesV2(orderKey, notificationId, search, {
    enabled: isPolling,
    refetchInterval: isPolling ? 2000 : 0,
    onSuccess: (data) => {
      if (data.IsComplete) {
        setIsPolling(false)
      }
    }
  })

  useEffect(() => {
    if (getIdCheckUrlSuccess && !notificationStatusesQuery.data?.IsComplete && !openedIdCheckUrl) {
      window.open(getIdCheckUrlSuccess.url, '_blank')
      setIdCheckUrl(getIdCheckUrlSuccess.url ?? '')
      setOpenedIdCheckUrl(true)
      resetGetIdCheckUrl({ loading: false })
    } else if (!notificationStatusesQuery.data?.IsComplete && openedIdCheckUrl && !prevIsVisible && isVisible) {
      setIsPolling(true)
      setOpenedIdCheckUrl(false)
    }
  }, [getIdCheckUrlSuccess, resetGetIdCheckUrl, openedIdCheckUrl, notificationStatusesQuery.data?.IsComplete, isVisible, prevIsVisible])

  const handleIdCheckClick = () => {
    setIsPolling(false)
    refreshGetIdCheckUrl()
  }

  const startPolling = () => {
    setIsPolling(true)
  }

  return {
    idCheckUrl,
    isPolling,
    getIdCheckUrlLoading,
    handleIdCheckClick,
    startPolling,
    isComplete: !!notificationStatusesQuery.data?.IsComplete,
    error: getIdCheckUrlError
  }
}
